import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  active: {
    maxHeight: 52,
    opacity: 1,
  },
}));

export default {
  useStyles,
};
